<mat-tab-group
  [(selectedIndex)]="selectedTab"
  (selectedTabChange)="tabChanged($event)"
  class="custom-tab-group"
>
  @for (s of solapas; track s.id) {
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">{{ s.icono }}</mat-icon>
        <span>{{ s.label }}</span>
        @if (s.contador) {
          <span class="tab-contador">
            {{ s.contador.toLocaleString('es-AR') }}
          </span>
        }
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>

<div class="tab-content-scroll">
  @switch (solapaActual) {
    @case ('auxilios') {
      <app-listado-emergencias-tabla
        solapa="auxilios"
        (cambio)="refrescarContadores()"
      ></app-listado-emergencias-tabla>
    }
    @case ('seguimiento') {
      <app-listado-emergencias-tabla
        solapa="seguimiento"
        (cambio)="refrescarContadores()"
      ></app-listado-emergencias-tabla>
    }
    @case ('historico') {
      <app-listado-emergencias-tabla
        solapa="historico"
        (cambio)="refrescarContadores()"
      ></app-listado-emergencias-tabla>
    }
  }
</div>
